import * as api from '../api';

// eslint-disable-next-line
export const fetchPurchaseOrderCategories = (args) => {
  return api.callGet('/manager/purchase-order-category', args);
};
